import React from 'react';
import AboutNav from './AboutNav';
import AboutPage from './Aboutpage';
import AboutUs from './AboutUs';
import Footer from './Footer';

export default function AboutRoute() {
  return (
    <>
      < AboutNav />
      < AboutPage />
      < AboutUs />
      < Footer />
    </>
  );
}
